import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import _get from 'lodash/get';
import merge from 'lodash/merge';
import _clonedeep from 'lodash/cloneDeep';
import {
  setNextFacets,
  removeFacets,
  setCurentFacetsQuery
} from '../../../../../../../actions/shared/facets';
import { showSnackbar, hideSnackbar } from '../../../../../../../actions/shared/snackbar';
import { getBestFilterId, getBestFilterName } from './plpFilter';

import queryUtil from '../../../../../../../modules/ajio-util/query';
import properties from '../../../../../../../modules/ajio-util/properties';
import productsUtil, {
  parseProductQueryString,
  stringifyFacets
} from '../../../../../../../utils/products';
import FacetFilterModalRightPane from './FacetFilterModalRightPane';
import BottomToolbar from '../../../../../../../components/common/BottomToolbar';

import { hideModal } from '../../../../../../../actions/modal';
import { isLandingPage } from '../../../../../../../utils/common';
import { generateEvent } from '../../../../../../../utils/dataGrinch';
import Dialog from '../../../../../../molecules/Dialog';
import Loader from '../../../../../../atoms/Loader';
import { showLoader } from '../../../../../../../actions/shared/loader.js';
import {
  gtmEventPush,
  gtmEventPushPLP,
  segmentEventPush
} from '../../../../../../../modules/ga/GTMdatalayer';
import Form from '../../../../../../../components/common/Form.js';
import Icon from '../../../../../../atoms/Icon';
import { getLuxeFlags } from '../../../../../../../Flags/selectors';
import {
  getPlpOnLandingEnabled,
  getFilterTabsOnLandingEnabled,
  getEnableFilterImprovement,
  getFilterImprovementConfig,
  getEnableFilterImprovementPhase2
} from '../../../../../../selectors/featureFlagsSelector';
import luxeScreen from '../../../../../../constants/luxeScreenType';
import { FLEEK_STORE } from '../../../../../../../constants/constant';
import { afterPaint } from '../../../../../../utils/deferAnalytics';

class CategoryFacetFilterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibility: false,
      isFilterReset: false,
      selectedFilter: '',
      floatLabelMin: false,
      floatLabelMax: false,
      minInputFocus: false,
      maxInputFocus: false,
      isFloatOrFocusChanged: false,
      keyboardOffset: 0
    };
    this.minInput = React.createRef();
    this.maxInput = React.createRef();
    this.modalRef = React.createRef();
    this.priceRangeFormRef = React.createRef();
  }

  handleViewportResize = () => {
    if (this.props.clickedFilterTabCode !== 'brand' || !window.visualViewport) return;
    const keyboardOffset = window.innerHeight - window.visualViewport.height;
    this.setState({ keyboardOffset: keyboardOffset > 0 ? keyboardOffset : 0 });
  };

  componentDidMount() {
    const {
      location = {},
      bestFilterId,
      clickedFilterTabCode = '',
      isPlpOnLandingEnabled = false,
      isFilterTabsOnLandingEnabled = false
    } = this.props;
    const isFilterTabClickedOnLanding =
      isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();
    const queryString = queryUtil.parseSearch(location.search) || {};
    const query = parseProductQueryString(queryString.query || '');
    const { facets = '' } = query;
    const facetsQuery = productsUtil.parseFacets(facets);
    this.props.setNextFacets(facetsQuery);

    const { selectedFilter } = this.state;
    if (isPlpOnLandingEnabled && isFilterTabClickedOnLanding) {
      !selectedFilter && this.selectFilter(clickedFilterTabCode);
    } else if (selectedFilter !== bestFilterId) {
      this.selectFilter(bestFilterId);
    }

    if (facets.length && isPlpOnLandingEnabled && isFilterTabsOnLandingEnabled && isLandingPage()) {
      this.props.updateFilterTabsCount(facets);
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleViewportResize);
    }
  }

  componentWillUnmount() {
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleViewportResize);
    }
  }

  componentDidUpdate() {
    const {
      bestFilterId,
      location = {},
      clickedFilterTabCode = '',
      isPlpOnLandingEnabled = false,
      isFilterTabsOnLandingEnabled = false
    } = this.props;
    const isFilterTabClickedOnLanding =
      isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();

    const { selectedFilter } = this.state;
    if (isPlpOnLandingEnabled && isFilterTabClickedOnLanding) {
      !selectedFilter && this.selectFilter(clickedFilterTabCode);
    } else if (selectedFilter !== bestFilterId) {
      this.selectFilter(bestFilterId);
    }
  }

  /**
   * Method to select filter on left hand side
   * filterId : "occasion"
   */
  selectFilter = filterId => {
    this.setState({ selectedFilter: filterId });
  };

  /**
   * Method to set the selected filters when clicking the values
   * values contains object which has the facetId of selected filters and their values
   * facetId = "genderfilter", values = {occasion: Array(1), genderfilter: Array(1)}
   */
  setRightPaneFormValues = (facetId, values) => {
    this.setState({ rightPaneFormValues: values }, () => {
      // if (
      //   facetId === 'l1l3nestedcategory' &&
      //   values.l1l3nestedcategory &&
      //   values.l1l3nestedcategory.length <= 4 &&
      //   values.l1l3nestedcategory.length > 0
      // ) {
      //   this.fetchNextFacets();
      // }
    });
  };

  /**
   * Method to select l1Category (Gender) in Category filter
   * l1Category = "girls"
   * l1Category = undefined if back button is clicked
   */
  setSeletedL1Category = l1Category => {
    this.setState({ seletedL1Category: l1Category });
  };

  setLastAppliedFacetQuery = facetQuery => {
    this.setState({ lastAppliedFacetQuery: facetQuery });
  };

  /**
   * Method to get the selected filters
   * values contains object which has the facetId of selected filters and their values
   * facetId = "genderfilter", values = {occasion: Array(1), genderfilter: Array(1)}
   */
  getSelectedFacets = () => {
    const { rightPaneFormValues = {} } = this.state;
    const { searchTerm, ...rest } = rightPaneFormValues;
    if (rest && Object.keys(rest).length < 1) {
      return;
    }
    return rest;
  };

  /**
   * Method which makes api call when clicking another filter
   * values contains object which has the facetId of selected filters and their values
   * facets : "occasion:Casual:occasion:Evening:occasion:Special Occasion:genderfilter:Men:brand:AERO BLUEZ:brand:AJIO:brickcfscategory:Footwear:pricerange:Rs.1001-1500:l1l3nestedcategory:Men - Casual shoes"
   */
  fetchNextFacets = () => {
    const selectedFacets = this.getSelectedFacets();
    if (selectedFacets) {
      generateEvent({
        Event: 'Filter',
        value: {
          ListOfFilters: qs.stringify(selectedFacets)
        }
      });
    }
    if (selectedFacets && this.props.fetchNextFacets) {
      this.props.fetchNextFacets({
        facets: stringifyFacets(selectedFacets)
      });
    }
    this.setState({ rightPaneFormValues: undefined });
  };

  /**
   * Method to get which filter is selected on left hand side
   * By default first filter will be open (selectedFilter = "l1l3nestedcategory")
   * If any other filter is selected then the function returns the facetCode
   * selectedFilter = "genderfilter"
   */

  getSelectedFilter() {
    let { selectedFilter } = this.state;
    const {
      items = [],
      entities = {},
      clickedFilterTabCode = '',
    } = this.props;
      selectedFilter = clickedFilterTabCode;
    if (!selectedFilter) {
      const id = items[0];
      const entity = entities[id] || {};
      selectedFilter = entity.code;
    }

    return selectedFilter;
  }

  getFormDefaultValues() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  getBestOrClickedFilterName() {
    const {
      bestFilterName,
      entities,
      clickedFilterTabCode = '',
      location = {},
      isPlpOnLandingEnabled = false,
      isFilterTabsOnLandingEnabled = false
    } = this.props;
    const isFilterTabClickedOnLanding =
      isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();

    return _get(entities, [clickedFilterTabCode, 'name'], '');
  }

  updateClass = () => {
    this.setState(prevState => ({
      minInputFocus: true,
      floatLabelMin: true,
      isFloatOrFocusChanged: !prevState.isFloatOrFocusChanged
    }));
  };

  removeClass = event => {
    const inputValue = event?.target?.value || '';
    this.setState(prevState => ({
      minInputFocus: false,
      isFloatOrFocusChanged: !prevState.isFloatOrFocusChanged,
      ...(inputValue.length === 0 && { floatLabelMin: false })
    }));
  };

  updateMaxClass = () => {
    this.setState(prevState => ({
      maxInputFocus: true,
      floatLabelMax: true,
      isFloatOrFocusChanged: !prevState.isFloatOrFocusChanged
    }));
  };

  removeMaxClass = event => {
    const inputValue = event?.target?.value || '';
    this.setState(prevState => ({
      maxInputFocus: false,
      isFloatOrFocusChanged: !prevState.isFloatOrFocusChanged,
      ...(inputValue.length === 0 && { floatLabelMax: false })
    }));
  };

  resetFilterTabsSelectedFacets = (event, isPriceCustomRangeClear = false) => {
    const { clickedFilterTabCode, facetsQuery } = this.props;
    let selectedFacets = this.getSelectedFacets() || this.getFormDefaultValues();
    const selectedFacetsCopy = _clonedeep(selectedFacets);
    this.setLastAppliedFacetQuery(selectedFacetsCopy);

    if (isPriceCustomRangeClear) {
      this.setState({
        isFilterReset: true
      });
      return;
    }

    if (clickedFilterTabCode === 'pricerange' && selectedFacets?.price) {
      delete selectedFacets['price'];
      this.removeClass();
      this.removeMaxClass();
      event.stopPropagation();
    }
    delete selectedFacets[clickedFilterTabCode];
    this.props.fetchNextFacets(selectedFacets);
    this.props.removeFacets('priceFacets');
    this.setState({
      rightPaneFormValues: selectedFacets,
      isPriceRangeFormReset: true,
      isFilterReset: true
    });
    this.props.handleFilterResetGAEvent('static');
  };

  handlePriceRangeSubmit = (event, isPriceFilterFromPlpLandingPage) => {
    event.preventDefault();
    const priceRangeFormRefData = this.priceRangeFormRef?.current;
    if (!priceRangeFormRefData) return false;

    const { setFormState, validateForm, submitForm } = priceRangeFormRefData;
    setFormState({ currAction: 'submit' });
    if (validateForm()) {
      submitForm({ isPriceFilterFromPlpLandingPage });
      return true;
    }
    return false;
  };

  iphoneKeyboardView = () => {
    setTimeout(() => {
      if (this.state.visibility) {
        this.minInput.current.focus();
        this.minInput.current.click();
      }
    }, 0);
  };

  renderPriceModal(luxe, isFleek) {
    const selectedFilter = this.getSelectedFilter();
    const {
      entities = {},
      location = {},
      clickedFilterTabCode = '',
      isPlpOnLandingEnabled = false,
      isFilterTabsOnLandingEnabled = false
    } = this.props;
    const entity = entities[selectedFilter] || {};
    const { code } = entity;
    const {
      rightPaneFormValues = {},
      floatLabelMin = false,
      floatLabelMax = false,
      minInputFocus = false,
      maxInputFocus = false
    } = this.state;
    if (code !== 'pricerange') {
      return null;
    }
    const priceSubmitDisable = !(this.minInput.current?.value && this.maxInput.current?.value);
    const isFilterTabClickedOnLanding =
      isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();
    return (
      // <Modal name={"price-modal"} className={"price-modal"}>
      <>
        {this.state.visibility && (
          <Dialog
            showDialog={this.state.visibility}
            type="drawer"
            customClass={luxe && 'luxe-dialog'}
            onCancel={() => this.showHidePriceRangeModal(false)}
            callbackOnVisible={this.iphoneKeyboardView}
            ariaLabel="Enter Price Range Screen"
          >
            <Form
              defaultValues={(() => {
                const defaultValues = this.getFormDefaultValues();
                let defaultPriceValues = [];
                if (rightPaneFormValues && rightPaneFormValues.price) {
                  defaultPriceValues = rightPaneFormValues.price;
                }
                let priceRange = defaultValues.price || [];
                if (defaultPriceValues.length) {
                  priceRange = defaultPriceValues;
                }
                let priceRangeSplits = priceRange[0] ? priceRange[0].split(',') : [];
                return {
                  minPrice: priceRangeSplits[0],
                  maxPrice: priceRangeSplits[1]
                };
              })()}
              onSubmit={formValues => {
                let defaultValues = this.getFormDefaultValues();
                const values = defaultValues || rightPaneFormValues;
                values.price = [`${formValues.minPrice},${formValues.maxPrice}`];
                if (values.pricerange) {
                  delete values.pricerange;
                }
                const { searchTerm, ...rest } = values;
                if (rest && Object.keys(rest).length > 0) {
                  this.props.fetchNextFacets({ facets: stringifyFacets(rest), cb: () => {
                    this.props.onNoProductsFound && this.props.onNoProductsFound();
                  }});
                }
                generateEvent({
                  Event: 'Filter',
                  value: {
                    ListOfFilters: qs.stringify(rest)
                  }
                });

                this.showHidePriceRangeModal(false);
                luxe && this.setState({ hasPriceFilterSubmit: true });
              }}
              validateForm={formValues => {
                let { minPrice, maxPrice } = formValues;
                minPrice = parseInt(minPrice);
                maxPrice = parseInt(maxPrice);
                if (minPrice == 0) {
                  return { error: 'Min Price should be greater than 0' };
                } else if (!minPrice || !maxPrice) {
                  return { error: 'Please enter your price range' };
                } else if (minPrice > maxPrice) {
                  return {
                    error: 'Min Price cannot be greater than Max Price'
                  };
                } else if (minPrice == maxPrice) {
                  return { error: 'Min and Max Price cannot be same' };
                } else if (minPrice > 0 && maxPrice > 0) {
                  return {};
                } else {
                  return {};
                }
              }}
            >
              {({
                getFormDefaultProps,
                getFormValue,
                isTouched,
                addFormValue,
                formValues,
                formError
              }) => (
                <div
                  className={`${luxe ? 'luxe-price-container' : 'price-container'} ${
                    isFleek ? 'ajiogram' : ''
                  }`}
                >
                  <div className="input-price-filter">
                    {luxe ? (
                      <div className="luxe-price-range-title" role="heading" aria-level={2}>
                        Price Range
                      </div>
                    ) : (
                      <div
                        className="price-range-title"
                        style={isFleek ? { color: '#FFF' } : {}}
                        role="heading"
                        aria-level={2}
                      >
                        Enter Price Range
                      </div>
                    )}
                    <div className="facet-min-price-filter">
                      <div
                        className={`${luxe ? 'filterLuxeRange' : 'filterRange'} filterMin ${
                          luxe
                            ? (floatLabelMin || !!getFormValue('minPrice')) && 'luxeFloatingLabel'
                            : (floatLabelMin || !!getFormValue('minPrice')) && 'floatingLabel'
                        } ${isFleek && (minInputFocus || !!getFormValue('minPrice')) ? 'fleekFloatingLabel' : ''}`}
                        style={isFleek ? { background: '#1B1F23' } : {}}
                      >
                        <label htmlFor="minPrice" style={isFleek ? { color: '#FFF' } : {}}>
                          Min
                        </label>
                        <input
                          {...getFormDefaultProps({
                            type: 'text',
                            pattern: 'd*',
                            name: 'minPrice'
                          })}
                          onChange={event => {
                            const { name, value } = event.target;
                            const isNum = /^\d+$/.test(value);
                            if (value != null && isNum) {
                              addFormValue(name, value);
                            } else if (value == '') {
                              addFormValue(name, value);
                            }
                          }}
                          id="minPrice"
                          // autoFocus={!navigator.userAgent.match('iPhone')}
                          ref={this.minInput}
                          maxLength="6"
                          onFocus={this.updateClass}
                          onBlur={this.removeClass}
                          style={isFleek ? { color: '#FFF', background: '#1B1F23' } : {}}
                        />
                      </div>
                      {/* <div className="minPrice">
                      <Input
                        {...getFormDefaultProps({
                            type: "text",
                            pattern: "d*",
                            name: "minPrice"
                          })}
                        id="minPrice"
                        maxLength={6}
                        label="Min"
                        onChange={this.handlePriceRange}
                      />
                      </div> */}
                      {isFleek ? (
                        <div style={{ color: '#FFF', margin: '0 10px' }} aria-hidden="true">
                          -
                        </div>
                      ) : luxe ? (
                        <div style={{ margin: '0 10px' }} aria-hidden="true">
                          -
                        </div>
                      ) : (
                        <Icon
                          icon="icon-Subtract"
                          styles={isFleek ? { color: '#FFF', margin: '0 10px' } : {}}
                          ariaHidden={true}
                        />
                      )}

                      {/* <Icon icon="icon-Subtract" /> */}

                      <div
                        className={`${luxe ? 'filterLuxeRange' : 'filterRange'} ${
                          luxe ? 'luxeFilterMax' : 'filterMax'
                        } ${
                          luxe
                            ? (floatLabelMax || !!getFormValue('maxPrice')) && 'luxeFloatingLabel'
                            : (floatLabelMax || !!getFormValue('maxPrice')) && 'floatingLabel'
                        } ${isFleek && (maxInputFocus || !!getFormValue('maxPrice')) ? 'fleekFloatingLabel' : ''}`}
                        style={isFleek ? { background: '#1B1F23' } : {}}
                      >
                        <label htmlFor="maxPrice" style={isFleek ? { color: '#FFF' } : {}}>
                          Max
                        </label>
                        <input
                          {...getFormDefaultProps({
                            type: 'text',
                            pattern: 'd*',
                            name: 'maxPrice'
                          })}
                          onChange={event => {
                            const { name, value } = event.target;
                            const isNum = /^\d+$/.test(value);
                            if (value != null && isNum) {
                              addFormValue(name, value);
                            } else if (value == '') {
                              addFormValue(name, value);
                            }
                          }}
                          ref={this.maxInput}
                          id="maxPrice"
                          maxLength="6"
                          onFocus={this.updateMaxClass}
                          onBlur={this.removeMaxClass}
                          style={isFleek ? { color: '#FFF', background: '#1B1F23' } : {}}
                        />
                      </div>
                      {/* <div className="maxPrice"> */}
                      {/* <label htmlFor="maxPrice">Max</label>
                      <input
                        {...getFormDefaultProps({
                          type: "text",
                          pattern: "d*",
                          name: "maxPrice"
                        })}
                        onChange={event => {
                          const { name, value } = event.target;
                          const isNum = /^\d+$/.test(value);
                          if (value != null && isNum) {
                            addFormValue(name, value);
                          } else if (value == "") {
                            addFormValue(name, value);
                          }
                        }}
                        id="maxPrice"
                        maxLength="6"
                      /> */}
                      {/* <Input
                           {...getFormDefaultProps({
                          type: "text",
                          pattern: "d*",
                          name: "maxPrice"
                        })}
                          id="maxPrice"
                          maxLength={6}
                          label="Max"
  
                          onChange={this.handlePriceRange}
                          
                        /> */}
                      {/* </div> */}
                      {!luxe && (
                        <button
                          type="submit"
                          className={`rilrtl-button rilrtl-button--primary button--apply priceRangeButton ${
                            isFleek ? 'fleekPriceRangeButton' : ''
                          }`}
                          style={isFleek && priceSubmitDisable ? { background: '#6B6D70' } : {}}
                        >
                          Done
                        </button>
                      )}
                    </div>
                    {luxe && formError.error && (
                      <div className="price-error">{formError.error}</div>
                    )}
                    {luxe && (
                      <div style={{ marginTop: '24px' }}>
                        <button
                          type="submit"
                          className="rilrtl-button rilrtl-button--primary button--apply luxePriceRangeButton"
                        >
                          Done
                        </button>
                      </div>
                    )}
                    {!luxe && formError.error && (
                      <div className="price-error" aria-live="assertive" role="alert">
                        {formError.error}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Form>
          </Dialog>
        )}
      </>
    );
  }

  renderPriceRangeForm = (luxe, isFleek) => {
    const {
      floatLabelMin = false,
      floatLabelMax = false,
      minInputFocus = false,
      maxInputFocus = false,
      rightPaneFormValues = {},
      entity = {}
    } = this.state;
    const { code } = entity;
    const { plpOnLandingData } = this.props;
    const { noProductsForPriceFilter = false } = plpOnLandingData || {};

    let isPriceRangeUnset = false;
    const {
      location,
      clickedFilterTabCode = '',
      isPlpOnLandingEnabled = false,
      isFilterTabsOnLandingEnabled = false
    } = this.props;
    const selectedFacets = this.getFormDefaultValues() || rightPaneFormValues;
    const isFilterTabClickedOnLanding =
      isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();
    const isPriceModalOpened =
      isPlpOnLandingEnabled && isFilterTabClickedOnLanding && clickedFilterTabCode === 'pricerange';
    return (
      <Form
        ref={this.priceRangeFormRef}
        defaultValues={(() => {
          const defaultValues = this.getFormDefaultValues();
          const defaultPriceValues = rightPaneFormValues?.price || [];
          const priceRange = defaultPriceValues.length
            ? defaultPriceValues
            : defaultValues?.price || [];

          const [minPrice = '', maxPrice = ''] = priceRange[0]?.split(',') || [];
          isPriceRangeUnset = !minPrice && !maxPrice;
          return { minPrice, maxPrice };
        })()}
        onSubmit={(formValues, extraParams) => {
          const defaultValues = this.getFormDefaultValues() || rightPaneFormValues;
          const { minPrice, maxPrice } = formValues;
          if (minPrice && maxPrice) {
            defaultValues.price = [`${minPrice},${maxPrice}`];
          }
          if (defaultValues.pricerange) {
            delete defaultValues.pricerange;
          }

          const { searchTerm, ...filteredValues } = defaultValues;
          // if (filteredValues && Object.keys(filteredValues).length) {
          // const { isPriceFilterFromPlpLandingPage = false } = extraParams;
          this.props.applyFilter(filteredValues, true, () => {
            this.priceRangeFormRef.current?.resetAll();
          });
          // }

          this.setState({
            rightPaneFormValues: undefined,
            selectedFilter: undefined,
            isFilterReset: false
          });
          this.props.updateFilterTabsCount(stringifyFacets(filteredValues));
          this.props.handleFilterSortApplyGAEvent('filter', 'static', filteredValues);
          generateEvent({
            Event: 'Filter',
            value: {
              ListOfFilters: qs.stringify(filteredValues)
            }
          });
        }}
        validateForm={formValues => {
          let minPrice = parseInt(formValues.minPrice);
          let maxPrice = parseInt(formValues.maxPrice);

          if (!minPrice && !maxPrice) return {};
          if (!minPrice || !maxPrice) return { error: 'Please enter your price range' };
          if (minPrice === 0) return { error: 'Min Price should be greater than 0' };
          if (minPrice > maxPrice) return { error: 'Min Price cannot be greater than Max Price' };
          if (minPrice === maxPrice) return { error: 'Min and Max Price cannot be the same' };

          return {};
        }}
      >
        {({
          getFormDefaultProps,
          getFormValue,
          isTouched,
          addFormValue,
          formValues,
          formError
        }) => {
          if (
            isPriceRangeUnset &&
            this.state.isPriceRangeFormReset &&
            this.priceRangeFormRef?.current
          ) {
            this.priceRangeFormRef.current?.resetAll();
            this.setState({ isPriceRangeFormReset: false });
            isPriceRangeUnset = false;
          }
          return (
            <div className={luxe ? 'input-price-luxe-filter' : 'input-price-filter'}>
              <div className="price-label">
                <span
                  htmlFor="min-price"
                  className="price-range"
                  style={isFleek ? { color: '#FFF' } : {}}
                  role="heading"
                  aria-level={2}
                >
                  <strong>Price Range</strong>
                </span>
                <span
                  className={luxe ? 'luxe-clear-price-filter' : 'clear-price-filter'}
                  style={isFleek ? { color: '#EBFF00' } : {}}
                  onClick={e => {
                    let defaultValues = this.getFormDefaultValues();
                    const values = rightPaneFormValues || defaultValues;
                    values.price = [];
                    this.props.removeFacets('priceFacets');
                    this.setRightPaneFormValues(code, values);
                    const { searchTerm, ...rest } = values;
                    if (facetsQuery.price) {
                      this.props.fetchNextFacets(rest);
                    }
                    this.removeMaxClass('clear');
                    this.removeClass('clear');
                    e.stopPropagation();
                  }}
                  role="button"
                  tabIndex={0}
                >
                  Clear
                </span>
              </div>

              <div className="facet-min-price-filter">
                <div
                  className={`transCursor ${luxe ? 'filterLuxeRange' : 'filterRange'} filterMin ${
                    floatLabelMin ? 'floatingLabel' : ''
                  }`}
                  style={isFleek ? { background: '#1B1F23' } : {}}
                >
                  <input
                    type="text"
                    pattern="\d*"
                    name="minPrice"
                    placeholder={isFleek ? '' : 'Min'}
                    style={isFleek ? { color: '#FFF', background: '#1B1F23' } : {}}
                    id="minPlp"
                    onFocus={() => {
                      // this.updateClass();
                      this.props.showHidePriceRangeModal(true);
                    }}
                    value={this.props.priceRangeSplits[0] || ''}
                    onBlur={e => this.removeClass(e)}
                    className={isFleek ? 'fleek-price-input' : ''}
                  />
                  <label htmlFor="minPrice" style={isFleek ? { color: '#FFF' } : {}}>
                    Min
                  </label>
                </div>
                {/* <span className="ic-price-separator" /> */}
                {isFleek ? (
                  <div
                    style={{ color: '#FFF', margin: '0 10px' }}
                    aria-label="-"
                    aria-hidden="true"
                  >
                    -
                  </div>
                ) : luxe ? (
                  <div style={{ margin: '0 10px' }} aria-label="-" aria-hidden="true">
                    -
                  </div>
                ) : (
                  <Icon
                    icon="icon-Subtract"
                    styles={isFleek ? { color: '#FFF', margin: '0 10px' } : {}}
                    ariaLabel="-"
                    ariaHidden={true}
                  />
                )}
                <div
                  className={`transCursor ${luxe ? 'filterLuxeRange' : 'filterRange'} ${
                    luxe ? 'luxeFilterMax' : 'filterMax'
                  }  ${floatLabelMax && 'floatingLabel'}`}
                  style={isFleek ? { background: '#1B1F23' } : {}}
                >
                  <input
                    type="text"
                    pattern="\d*"
                    name="maxPrice"
                    placeholder={isFleek ? '' : 'Max'}
                    style={isFleek ? { color: '#FFF', background: '#1B1F23' } : {}}
                    onFocus={() => {
                      this.props.showHidePriceRangeModal(true);
                      // this.updateMaxClass();
                    }}
                    value={this.props.priceRangeSplits[1] || ''}
                    onBlur={e => this.removeMaxClass(e)}
                    // onBlur={this.removeMaxClass}
                    className={isFleek ? 'fleek-price-input' : ''}
                  />
                  <label htmlFor="maxPrice" style={isFleek ? { color: '#FFF' } : {}}>
                    Max
                  </label>
                </div>
                {/* <Input
                        type="number"
                        pattern="\d*"
                        name="minPrice"
                        label="Min"
                        onFocus={() => {
                          this.props.showHidePriceRangeModal(true);
                        }}
                        value={priceRangeSplits[0] || ""}
                      />
                      <Icon icon="icon-Subtract" />
                      <Input
                        type="number"
                        pattern="\d*"
                        name="maxPrice"
                        label="Max"
                        onFocus={() => {
                          this.props.showHidePriceRangeModal(true);
                        }}
                        value={priceRangeSplits[1] || ""}
                      /> */}
                {!luxe && (
                  <span className="price-total-count">
                    {this.props.priceFacets.totalResults != null &&
                    this.props.priceFacets.totalResults > 0
                      ? `(${this.props.priceFacets.totalResults})`
                      : null}
                  </span>
                )}
              </div>
              {!luxe && (
                <div className="input-price-filter-error-container">
                  {this.props.priceFacets.totalResults === 0 &&
                  this.props.priceRangeSplits.length ? (
                    <span>
                      There are no products available for this price range. Please clear price
                      range.
                    </span>
                  ) : null}
                </div>
              )}
            </div>
          );
        }}
      </Form>
    );
  };

  // method for price filter, it is empty as price is common filter
  showHidePriceRangeModal = boolean => {
    this.setState({ visibility: boolean });
  };

  render() {
    const {
      location,
      totalResults,
      priceFacets,
      isLoadingFacets,
      switchToAllFilter,
      bestFilterName,
      name,
      luxeFlags,
      pushToHistory,
      clickedFilterTabCode = '',
      isPlpOnLandingEnabled = false,
      isFilterTabsOnLandingEnabled = false,
      is_GA4 = false,
      isFilterImprovementEnabled,
      isFilterImprovementPhase2Enabled,
      filterImprovementConfig,
      facets = {},
      isLimitedScrollLandingPage = false,
      isFromPopup = false
    } = this.props;
    const isFilterTabClickedOnLanding =
      isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    const isFleek = name === FLEEK_STORE;
    const { hash = '' } = location;
    let isApplyBtnDisabled = false;
    if (priceFacets && priceFacets.totalResults != null && priceFacets.totalResults == 0) {
      isApplyBtnDisabled = true;
    }
    const imageBaseUrl = properties.getProperty('imageBaseUrl');
    const url = `${imageBaseUrl}/static/img/refreshsitespinner.gif`;

    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    const isPriceModalOpened =
      isPlpOnLandingEnabled && isFilterTabClickedOnLanding && clickedFilterTabCode === 'pricerange';
    const isPlpOnLandingRequest = isPlpOnLandingEnabled && isFilterTabClickedOnLanding;

    return (
      this.props.categoryModal && (
        <Dialog
          showDialog={this.props.categoryModal}
          type="drawer"
          customClass={luxe && 'luxe-dialog'}
          ariaLabel={this.getBestOrClickedFilterName()}
          {...(clickedFilterTabCode === 'brand' && this.state.keyboardOffset > 0
            ? { modalStyles: { height: `${window.innerHeight - this.state.keyboardOffset}px` } }
            : {})}
          onCancel={() => {
            if (isLimitedScrollLandingPage) {
              const { isFilterReset, lastAppliedFacetQuery } = this.state;
              const stringifiedFacetsQuery = JSON.stringify(lastAppliedFacetQuery);
              const stringifiedFacetsLastAppliedQuery = JSON.stringify(this.props.facetsQuery);

              if (stringifiedFacetsQuery !== stringifiedFacetsLastAppliedQuery && isFilterReset) {
                this.props.fetchNextFacets(lastAppliedFacetQuery);
                this.setState({ rightPaneFormValues: lastAppliedFacetQuery });
              }
            }
            this.props.updateCategoryModal(false);
          }}
        >
          {this.props.categoryModal || isPriceModalOpened ? (
            <>
              {isLoadingFacets ? <Loader url={url} /> : null}
              <div
                className={luxe ? 'luxe-facet-categoryfilter-head' : 'facet-categoryfilter-head'}
                style={isFleek ? { background: '#2E343A' } : {}}
              >
                <div
                  className="facet-categoryfilter-modalHeading"
                  style={isFleek ? { color: '#FFF' } : {}}
                  role="heading"
                  tabIndex={0}
                >
                  <strong aria-hidden="true">{this.getBestOrClickedFilterName()}</strong>
                </div>
                {clickedFilterTabCode === 'l1l3nestedcategory' ? (
                  <div
                    role="button"
                    className="facet-categoryfilter-modalSubHeading"
                    onClick={switchToAllFilter}
                    style={isFleek ? { color: '#EBFF00' } : {}}
                    tabIndex={0}
                  >
                    <strong>View all filters</strong>
                  </div>
                ) : null}
              </div>
              <div
                style={
                  clickedFilterTabCode !== 'l1l3nestedcategory'
                    ? { maxHeight: '60vh', overflowY: 'auto', paddingBottom: '30px' }
                    : {}
                }
              >
              <div
                className={`${luxe ? 'facet-luxe-categoryfilter-body' : 'facet-categoryfilter-body'}${clickedFilterTabCode === 'brand' ? ' brand-filter-body' : ''}`}
              >
                <FacetFilterModalRightPane
                  popupFilterFromBottom
                  selectFilter={this.selectFilter}
                  selectedFilter={clickedFilterTabCode}
                  setRightPaneFormValues={this.setRightPaneFormValues}
                  rightPaneFormValues={this.state.rightPaneFormValues}
                  seletedL1Category={this.state.seletedL1Category}
                  setSeletedL1Category={this.setSeletedL1Category}
                  selectedFacets={this.getSelectedFacets()}
                  fetchFacets={this.props.fetchNextFacets}
                  pushToHistory={this.props.pushToHistory}
                  clickedFilterTabCode={clickedFilterTabCode}
                  renderPriceRangeForm={this.renderPriceRangeForm}
                  isFloatOrFocusChanged={this.state.isFloatOrFocusChanged}
                  fetchNextFacets={this.fetchNextFacets}
                  showHidePriceRangeModal={this.showHidePriceRangeModal}
                  showSearchBar={!luxe}
                  isFilterImprovementEnabled={isFilterImprovementEnabled}
                  isFilterImprovementPhase2Enabled={isFilterImprovementPhase2Enabled}
                  filterImprovementConfig={filterImprovementConfig}
                  facets={facets}
                  isLimitedScrollLandingPage={isLimitedScrollLandingPage}
                  isFromPopup={isFromPopup}
                  resetFilterTabsSelectedFacets={this.resetFilterTabsSelectedFacets}
                />
              </div>
              </div>
              {this.renderPriceModal(luxe, isFleek)}
              <div>
                <BottomToolbar className={`rilrtl-toolbar--bottom-facets-popup`} isFleek={isFleek}>
                  <button
                    type="button"
                    className={
                      luxe
                        ? 'rilrtl-button rilrtl-button--luxeSecondary button--reset'
                        : 'rilrtl-button rilrtl-button--secondary button--reset'
                    }
                    style={
                      isFleek
                        ? { background: '#060C10', color: '#EBFF00', border: '1px solid #EBFF00' }
                        : {}
                    }
                    onClick={event => {
                      // this.props.fetchNextFacets({
                      //   facets: ""
                      // });
                      // this.props.removeFacets("priceFacets");
                      // this.setState({ rightPaneFormValues: undefined });
                      if (isLimitedScrollLandingPage) {
                        this.resetFilterTabsSelectedFacets(event);
                      } else {
                        this.props.updateCategoryModal(false);
                      }
                    }}
                    aria-label={
                      isFleek || (isPlpOnLandingEnabled && isFilterTabClickedOnLanding)
                        ? 'Reset'
                        : 'Cancel'
                    }
                  >
                    <strong>
                      {isFleek || (isPlpOnLandingEnabled && isFilterTabClickedOnLanding)
                        ? 'Reset'
                        : 'Cancel'}
                    </strong>
                  </button>

                  <button
                    type={isPlpOnLandingRequest ? 'button' : 'submit'}
                    ref="submitBtn"
                    className={`${
                      luxe
                        ? 'rilrtl-button rilrtl-button--luxePrimary button--apply'
                        : 'rilrtl-button rilrtl-button--primary button--apply'
                    } ${isApplyBtnDisabled ? 'rilrtl-button--disabled' : ''}`}
                    style={
                      isFleek
                        ? { background: '#EBFF00', color: '#060C10', border: '1px solid #EBFF00' }
                        : {}
                    }
                    onClick={afterPaint(event => { // eslint-disable-line prettier/prettier
                      if (isApplyBtnDisabled) {
                        this.props.showSnackbar('price-filter-bar');
                        setTimeout(() => {
                          this.props.hideSnackbar('price-filter-bar');
                        }, 3000);
                        return false;
                      }
                      let facets = this.getSelectedFacets();
                      if (!facets) {
                        facets = this.props.facetsQuery || {};
                      }

                      if (is_GA4) {
                        if (luxe) {
                          gtmEventPush({
                            event: 'plp_filter_apply',
                            event_category: 'product list interactions',
                            event_action: 'filter applied',
                            event_label: Object.values(facets).toString(),
                            no_of_filters: Object.keys(facets).length,
                            store_type: name,
                            page_name: screenName,
                            page_type: screenType
                          });
                        } else {
                          gtmEventPushPLP({
                            event: 'plp_filter_interaction',
                            event_category: 'plp_interaction',
                            event_action: 'plp_category_filter_applied',
                            filters_name: Object.keys(facets).toString(),
                            filters_value: Object.values(facets).toString(),
                            is_GA4
                          });
                        }
                      } else {
                        if (luxe) {
                          gtmEventPush({
                            event: 'plp_filter_apply',
                            event_category: 'product list interactions',
                            event_action: 'filter applied',
                            event_label: Object.values(facets).toString(),
                            no_of_filters: Object.keys(facets).length,
                            store_type: name,
                            page_name: screenName,
                            page_type: screenType
                          });
                        } else {
                          gtmEventPush({
                            event: 'productfilter_apply',
                            filters_name: Object.keys(facets).toString(),
                            filters_value: Object.values(facets).toString(),
                            event_category: 'product list interactions'
                          });
                        }
                      }

                      generateEvent({
                        Event: 'Filter',
                        value: {
                          ListOfFilters: qs.stringify(facets)
                        }
                      });
                      window.ga &&
                        window.ga('send', {
                          hitType: 'event',
                          eventCategory: 'Filter',
                          eventAction: 'Filter Applied',
                          eventLabel: `${Object.keys(facets).toString()}_${Object.values(
                            facets
                          ).toString()}`
                        });

                      segmentEventPush({
                        event: 'Plp Category Applied',
                        event_category: 'plp_interaction',
                        event_action: 'plp_category_filter_applied',
                        no_of_filters: Object.keys(facets).length,
                        l1_filter: `${Object.keys(facets).toString()}_${Object.values(
                          facets
                        ).toString()}`,
                        store_type: name,
                        page_name: screenName,
                        page_type: screenType,
                        category_type: this.seletedL1Category,
                        redirection_type: ''
                      });

                      // if (
                      //   isPlpOnLandingEnabled &&
                      //   isFilterTabClickedOnLanding &&
                      //   this.minInput?.current?.value &&
                      //   this.maxInput?.current?.value &&
                      //   clickedFilterTabCode === 'pricerange'
                      // ) {
                      const isPriceRangeSubmitted = this.handlePriceRangeSubmit(event, true);
                      if (isPriceRangeSubmitted) {
                        return;
                      }
                      // } else {
                      this.props.applyFilter(facets);
                      this.props.showVisualFilterLoader();
                      this.props.replaceInHistory({
                        facets: stringifyFacets(facets),
                        currentPage: 0,
                        isRequestFromPlpOnLanding: isPlpOnLandingRequest,
                        displayProductsOnLandingLoader: isPlpOnLandingRequest
                      });
                      this.setState({
                        rightPaneFormValues: undefined,
                        selectedFilter: undefined,
                        seletedL1Category: undefined,
                        isFilterReset: false
                      });
                      if (isPlpOnLandingEnabled && isFilterTabClickedOnLanding) {
                        this.props.updateFilterTabsCount(stringifyFacets(facets));
                        this.props.handleFilterSortApplyGAEvent('filter', 'static', facets);
                      }
                      this.props.updateCategoryModal(false);
                      // }
                    })} // eslint-disable-line prettier/prettier
                    aria-label="Apply filter"
                  >
                    <strong>Apply filter</strong>
                  </button>
                </BottomToolbar>
              </div>
            </>
          ) : null}
        </Dialog>
      )
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { request = {}, facets = {}, loaders = {}, flags, metaData } = state;
  const { name } = metaData;
  const { nextFacets = {}, totalResults = 0, priceFacets = {} } = facets;
  const { groupEntities = {}, entities = {}, query: facetsQuery = {} } = nextFacets;

  const { query: lastAppliedQuery = {} } = request;

  let items = [];
  if (groupEntities.All && groupEntities.All.items) {
    items = groupEntities.All.items;
  }

  const isLoadingFacets = !!loaders['fetching-next-facets'];

  const { clickedFilterTabCode = '' } = ownProps;
  const bestFilterId = clickedFilterTabCode ? '' : getBestFilterId(state);
  const bestFilterName = clickedFilterTabCode ? '' : getBestFilterName(state);
  const isFilterImprovementEnabled = getEnableFilterImprovement(state);
  const filterImprovementConfig = getFilterImprovementConfig(state);

  return {
    items,
    entities,
    facetsQuery,
    totalResults,
    priceFacets,
    lastAppliedQuery,
    isLoadingFacets,
    bestFilterId,
    bestFilterName,
    name,
    luxeFlags: getLuxeFlags(flags),
    isPlpOnLandingEnabled: getPlpOnLandingEnabled(state),
    isFilterTabsOnLandingEnabled: getFilterTabsOnLandingEnabled(state),
    isFilterImprovementPhase2Enabled: getEnableFilterImprovementPhase2(state),
    isFilterImprovementEnabled,
    filterImprovementConfig
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setNextFacets: query => {
      dispatch(setNextFacets(query));
    },
    setCurentFacetsQuery: query => {
      dispatch(setCurentFacetsQuery(query));
    },
    showSnackbar: name => {
      dispatch(showSnackbar(name));
    },
    hideSnackbar: name => {
      dispatch(hideSnackbar(name));
    },
    removeFacets: id => {
      dispatch(removeFacets(id));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    showVisualFilterLoader: () => {
      dispatch(showLoader('visual-filter-loader'));
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CategoryFacetFilterModal));
